<template>
  <el-dialog v-model="visible" title="更换机型" width="500px" @close="handleClose">
    <div class="change-model-content">
      <div class="form-item">
        <label>云机名称</label>
        <div class="phone-name">{{ phoneName }}</div>
      </div>
      <div class="form-item">
        <label>产品品牌</label>
        <el-select v-model="selectedBrand" placeholder="请选择产品品牌" @change="handleBrandChange">
          <el-option v-for="item in brandList" :key="item.brand" :label="item.brand" :value="item.brand" />
        </el-select>
      </div>
      <div class="form-item">
        <label>云机机型</label>
        <el-select v-model="selectedModel" placeholder="请选择云机机型" :disabled="!selectedBrand">
          <el-option v-for="item in modelList" :key="item.id" :label="item.model" :value="item.id" />
        </el-select>
      </div>
      <div class="form-item">
        <el-checkbox v-model="resetData">重置云机数据</el-checkbox>
      </div>
    </div>
    <template #footer>
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" :disabled="!selectedModel" @click="handleConfirm">确认更换</el-button>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { ElMessage } from 'element-plus';
import request from '@/utils';

const emit = defineEmits(['changed']);

const visible = ref(false);
const phoneId = ref('');
const phoneName = ref('');
const androidVersion = ref('');
const selectedBrand = ref('');
const selectedModel = ref('');
const resetData = ref(false);
const brandList = ref<any[]>([]);

const modelList = computed(() => {
  const brand = brandList.value.find(b => b.brand === selectedBrand.value);
  return brand?.models || [];
});

const show = async (id: string, name: string, version: string) => {
  phoneId.value = id;
  phoneName.value = name;
  androidVersion.value = version;
  selectedBrand.value = '';
  selectedModel.value = '';
  resetData.value = false;

  try {
    const res = await request.get(`/realphone/list?android_version=${version}`);
    brandList.value = res.data.data;
    visible.value = true;
  } catch (error) {
    console.error('获取机型列表失败:', error);
  }
};

const handleBrandChange = () => {
  selectedModel.value = '';
};

const handleClose = () => {
  visible.value = false;
};

const handleConfirm = async () => {
  if (!selectedModel.value) {
    ElMessage.warning('请选择云机机型');
    return;
  }
  try {
    const requestData: any = {
      model_id: selectedModel.value,
      instance_use_ids: [Number(phoneId.value)],
      clear_data: resetData.value ? 'true' : 'false'
    };
    await request.post('/realphone/batch_change_model', requestData);
    ElMessage.success('更换机型成功，云手机重启中');
    emit('changed');
    handleClose();
  } catch (error) {
    console.error('更换机型失败:', error);
  }
};

defineExpose({ show });
</script>

<style scoped>
.change-model-content {
  padding: 10px 0;
}

.form-item {
  margin-bottom: 20px;
}

.form-item label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #606266;
}

.phone-name {
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 4px;
  font-size: 14px;
}
</style>
